import { Component, inject } from '@angular/core';
import { SeSignInfo } from '../../models/estensasign.model';
import { MatDialogContent, MAT_DIALOG_DATA, MatDialogRef, MatDialogActions, MatDialogTitle } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput, MatLabel, MatSuffix } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'se-comped-double-sign-auth-dialog',
    imports: [FormsModule, MatButtonModule, MatDialogActions, MatDialogContent, MatDialogTitle, MatFormField, MatIconModule, MatInput, MatLabel, MatSuffix],
    templateUrl: './comped-double-sign-auth-dialog.component.html',
    styleUrl: './comped-double-sign-auth-dialog.component.scss',
    standalone: true,
})
export class CompedDoubleSignAuthDialogComponent {
    data: SeSignInfo = inject(MAT_DIALOG_DATA);
    dialogRef = inject(MatDialogRef<CompedDoubleSignAuthDialogComponent>);
    translateService = inject(TranslateService);

    btnOkLabel = this.translateService.instant('Confirm');
    btnCancelLabel = this.translateService.instant('Cancel');
    title = this.translateService.instant('Sign') + ' - ' + this.translateService.instant('Authenticate');
    usernameLabel = this.translateService.instant('Username');
    pinLabel = this.translateService.instant('Pin');


    showPin: boolean = false;

    closeModal(cancelOps: boolean) {
        if (cancelOps) {
            this.dialogRef.close(null);
        } else {
            this.dialogRef.close(this.data);
        }
    }


}
